import {SRT_ORIGIN_ENTRY_POINT} from '@constants/resources';
import {SECURITY_PRIVILEGES_READ} from '@constants/variables';

export const authorizationObject = {
    [SRT_ORIGIN_ENTRY_POINT]: SECURITY_PRIVILEGES_READ,
};
